import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ActionButton, ListItem, TopNavigation } from "@hamlak/ui";
import { platform } from "@/platform";
import { t } from "@/i18n/ko";
import { storeKey, storeOf } from "@/i18n/codes";
import { useAuthStore } from "@/stores/authStore";
import { buildPrefillUrl } from "./buildPrefillUrl";
import { readDeviceAttachment, type DeviceAttachment } from "./supportForm";
import "@/features/me/me.css";
import "./settings.css";

/**
 * F07-16 고객센터(1.19). 제목·안내 → 자동 첨부 4행(회원번호·기기·OS·앱 버전, 시안 밖 유지) → "문의 남기기" →
 * platform.browser.open(buildPrefillUrl(…)). 폼 URL·entry 는 config/links 상수(AC0-230).
 */
export function SupportPage() {
  const navigate = useNavigate();
  const userId = useAuthStore((s) => s.user?.publicId ?? null); // 회원번호(AC0-96). UUID 는 사용자가 읽을 수 없어 첨부하지 않는다
  const [attached, setAttached] = useState<DeviceAttachment | null>(null);

  useEffect(() => {
    let alive = true;
    void readDeviceAttachment().then((v) => {
      if (alive) setAttached(v);
    });
    return () => {
      alive = false;
    };
  }, []);

  const submit = () => {
    void platform.browser.open(buildPrefillUrl({ ...(userId ? { userId } : {}), ...(attached ?? {}) }));
  };

  return (
    <main className="page" data-testid="support-page">
      <TopNavigation title={t("page.support")} right={null} onBack={() => navigate(-1)} />
      <div className="support__body">
        <h2 className="support__title">{t("support.title")}</h2>
        <div>
          <p className="support__guide">{t("support.guide.form")}</p>
          <p className="support__guide">{t(storeKey("support.guide.orderId", storeOf(platform.clientKind)))}</p>
          <p className="support__guide">{t("support.guide.sla")}</p>
        </div>
      </div>
      <p className="me__listHeader">{t("support.attached")}</p>
      <div className="me__menu">
        <ListItem title={t("support.userId")} detail={userId ?? t("support.guest")} suffix="none" disabled />
        <ListItem title={t("support.device")} detail={attached?.device ?? ""} suffix="none" disabled />
        <ListItem title={t("support.os")} detail={attached?.os ?? ""} suffix="none" disabled />
        <ListItem title={t("support.appVersion")} detail={attached?.appVersion ?? ""} suffix="none" disabled />
      </div>
      <div className="support__cta">
        <ActionButton size="mediumTall" block onClick={submit}>
          {t("support.cta")}
        </ActionButton>
        <p className="support__caption">{t("support.ctaCaption")}</p>
      </div>
    </main>
  );
}
